export const ssRoutes = [
    { key: 'SSSSOLD', route: '/suite-search/search' },
    { key: 'SSCROLD', route: '/suite-search/customer-review' }
];
